module.exports = __webpack_public_path__ + "static/media/back.278883bc.svg";